module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-sm\"> <div class=\"modal-content\"> <section class=\"modal-body\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> <p>Are you sure you want to remove this payment method?</p> </section> <section class=\"modal-footer\"> <button class=\"btn btn-red cancel\" type=\"button\"> Cancel </button> <button class=\"btn btn-blue confirm_remove\" type=\"button\"> Remove </button> </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/payment_method_remove_modal.ejs
// module id = 861
// module chunks = 1